import { mapPartrequestsState } from "../../../../utils/mapRequestStates";

export const getRequestStateLabel = (stateNumber) => {
    if (!stateNumber) return "N/A";
    const result = mapPartrequestsState([{ state: stateNumber }]);
    return result[0]?.state_label || "N/A";
};